import UpdateTime from "./time/update";

export default {
  modules: { UpdateTime },
};
